import { render, staticRenderFns } from "./IncomeOverview.vue?vue&type=template&id=88c9f730&"
import script from "./IncomeOverview.vue?vue&type=script&lang=js&"
export * from "./IncomeOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports